var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-action"},[_c('button',{staticClass:"pay-now",style:({ backgroundColor: _vm.buttonColor, color: _vm.buttonTextColor }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('pay-now')}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }